import { TERMINOLOGY } from '@shared/i18n';
import { SEARCH_TEMPLATES_CONDITION } from '@modules/search/constants';

import { IFolder, TRootItems } from '../types/folders.types';
import { EBindingMode, TItem } from '../types/items.types';

export const isTemplateSelectable = (_parent: IFolder | TRootItems, item: TItem): boolean =>
  item.type === 'DOCUMENT' && item.isTemplate && !!item.stats.approvedVersionId;

export const getTemplateDisabledReason = (item: TItem): string | undefined => {
  if (item.type === 'FOLDER') return undefined;
  if (item.type !== 'DOCUMENT') return 'Only documents can be selected.';
  if (!item.isTemplate) return `This document is not a ${TERMINOLOGY.template.lower}.`;
  if (!item.stats.approvedVersionId) return `This ${TERMINOLOGY.template.lower} has no approved version.`;
  return undefined;
};

// Omitting a folder id makes template search span every folder the user has READ access to.
export const TEMPLATE_SEARCH_OPTIONS = {
  templatesCondition: SEARCH_TEMPLATES_CONDITION.EXCLUSIVELY,
  placeholder: `Search ${TERMINOLOGY.template.lowerPlural}`,
};

export const getBindingModeOptions = (onBound: () => void, onDetached: () => void) => [
  {
    value: EBindingMode.BOUND,
    title: TERMINOLOGY.bound.upper,
    subtitle: 'Locked layout. Only fields are editable.',
    onClick: onBound,
  },
  {
    value: EBindingMode.DETACHED,
    title: TERMINOLOGY.detached.upper,
    subtitle: 'Full copy. Everything is freely editable.',
    onClick: onDetached,
  },
];
